import type { VFXEffectConfig } from '../../VFXEffectRegistry';
import { abilityPalette } from '../../abilityPalette';
import { ABILITY_SCHOOL_COLORS } from '../../../../shared/constants/AbilitySchoolColors';

export const DRAIN_LIFE_IMPACT_ID = 'drain_life_tick_impact';

const palette = abilityPalette('drain_life');
const shadow = palette?.palette[0] ?? ABILITY_SCHOOL_COLORS.shadow;
const edge = palette?.palette[2] ?? shadow;

/** A tick touches the target's edge; the channel link owns sustained motion. */
export const DRAIN_LIFE_IMPACT_VFX: VFXEffectConfig[] = [{
  id: DRAIN_LIFE_IMPACT_ID,
  name: 'Drain Life Contact',
  category: 'burst',
  description: 'Broken shadow rim and brief contact glint, leaving the target visible',
  primitives: [
    {
      type: 'arc', arcRadius: 15, arcStartAngle: -70, arcEndAngle: 65,
      color: shadow, alpha: 0.95, depth: 94, glow: true,
      stroke: { color: shadow, width: 2.5 },
      tween: { alpha: 0, scale: 1.15, duration: 260, ease: 'Sine.easeOut' },
    },
    {
      type: 'arc', arcRadius: 15, arcStartAngle: 110, arcEndAngle: 245,
      color: edge, alpha: 0.85, depth: 95,
      stroke: { color: edge, width: 1.5 },
      tween: { alpha: 0, scale: 1.15, duration: 220, ease: 'Sine.easeOut' },
    },
    {
      type: 'star', points: 4, innerRadius: 1, outerRadius: 3,
      offsetX: -13, color: edge, alpha: 0.9, depth: 96,
      tween: { alpha: 0, scale: 0.5, duration: 160, ease: 'Power2' },
    },
  ],
}];
